var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'node-image', _vm.item.classes ],style:(_vm.getItemStyle(_vm.item.rect))},[_c('img',{attrs:{"src":_vm.item.source,"alt":_vm.item.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }